import React from "react";
import "./css/footer.css";
import { Link } from "react-router-dom";
import PROXY from "../../proxy";

const path = PROXY + "/footer/img?img=",
  sfondo = path + "sfondo",
  logoBF = path + "bf_logo",
  logoRighi = path + "righi_logo",
  logoRegione = path + "regione_logo",
  logoComune = path + "comune_logo",
  logoAmbasciata = path + "ambasciata_logo",
  logoContadina = path + "contadina_logo",
  logoRisorgimento = path + "risorgimento_logoBianco",
  logoArchiginnasio = path + "archiginnasio_logo",
  logoOttocento = path + "8cento_logo",
  logoRadio = path + "radio_logo",
  logoComuneFerrara = path + "comuneferrara.png",
  logoParma = path + "parma.png",
  logoModena = path + "modenaarts.png";

export default function Footer() {
  return (
    <footer
      className="footer"
      style={{
        backgroundImage: `url("${sfondo}")`,
      }}
    >
      <div className="container">
        <div className="righe">
          <div className="colonne">
            <h3>
              <Link to="/bologna">Bologna</Link>
            </h3>
            <ul>
              <li>
                <Link to="/pellegrino">Albergo del Pellegrino</Link>
              </li>
              <li>
                <Link to="/certosa">Certosa</Link>
              </li>
              <li>
                <Link to="/pinacoteca">Pinacoteca</Link>
              </li>
              <li>
                <Link to="/torri">Centro: Due Torri, portici</Link>
              </li>
              <li>
                <Link to="/meridiana">
                  Centro: Chiese, San Petronio e la meridiana{" "}
                </Link>
              </li>
            </ul>
          </div>
          <div className="colonne">
            <h3>
                <Link to="/modena">
                  Modena{" "}
                </Link>
            </h3>
            <ul>
              <li>
                <Link to="/modena#4">
                  Cattedrale{" "}
                </Link>
              </li>
              <li>
                <Link to="/ducatomodena">
                  Ghirlandina{" "}
                </Link>
              </li>
              <li>
                <Link to="/ducatomodena">
                  Ducato di Modena e Reggio{" "}
                </Link>
              </li>
            </ul>
          </div>
          <div className="colonne">
            <h3>
              <Link>Ferrara</Link>
            </h3>
            <ul>
              <li>
                <Link to="/ferrara">Castello</Link>
              </li>
              <li>
                <Link  to="/ferrara">Cattedrale</Link>
              </li>
              <li>
                <Link  to="/pianourbanistico">Piano Urbanistico</Link>
              </li>
            </ul>
          </div>
          <div className="colonne">
            <h3>
                <Link to="/parma">
                  Parma{" "}
                </Link>
            </h3>
            <ul>
              <li>
                <Link to="/parma">
                  Cattedrale{" "}
                </Link>
              </li>
              <li>
                <Link to="/parma">
                  Battistero{" "}
                </Link>
              </li>
              <li>
                <Link to="/ducatoparma">
                  Ducato di Parma e Piacenza{" "}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <hr />
      </div>
      <h2>
        <Link to="/ringraziamenti" id="ringraziamenti">
          Autori e Ringraziamenti
        </Link>
      </h2>

      <h3 className="sottoTitolo">Realizzato da</h3>
      <div className="righe loghi">
        <a
          href="https://www.belluzzifioravanti.it/"
          title="Belluzzi Fioravanti"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoBF} alt="logoBF" />
        </a>
        <a
          href="https://www.liceorighibologna.it/"
          title="Liceo Righi"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoRighi} alt="logoRighi" />
        </a>
      </div>

      <h3 className="sottoTitolo">Con il patrocinio di </h3>
      <div className="righe loghi">
        <a
          href="https://www.regione.emilia-romagna.it/"
          title="Regione Emilia-Romagna"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoRegione} alt="logo Emilia Romagna" />
        </a>
        <a
          href="http://www.comune.bologna.it/"
          title="Comune di Bologna"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={logoComune}
            alt="logo Comune di Bologna"
            id="comuneBologna"
          />
        </a>
        <a
          href="https://www.gov.uk/world/organisations/british-embassy-rome.it"
          title="Ambasciata britannica Roma"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoAmbasciata} alt="logo Ambasciata britannica Roma" />
        </a>
        <a
          href="https://www.comune.parma.it"
          title="Comune Parma"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoParma} alt="logo Parma" />
        </a>

      </div>
      <div className="righe loghi">
      
      <a
          href="https://comune.fe.it"
          title="Comune Ferrara"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoComuneFerrara} alt="logo Comune Ferrara" />
        </a>
      <a
          href="https://modenafuturacreativa.it"
          title="Modena City of Arts"
          target="_blank"
          rel="noreferrer"
        >
        <img src={logoModena} alt="logo Modena" />
        </a>
        </div>

      <h3 className="sottoTitolo">In collaborazione con </h3>
      <div className="righe loghi">
        <a
          href="https://www.museociviltacontadina.bo.it/"
          title="Museo della Civiltà Contadina"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoContadina} alt="logo Museo della Civiltà Contadina" />
        </a>
        <a
          href="http://www.comune.bologna.it/museorisorgimento/"
          title="Museo Civico del Risorgimento"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={logoRisorgimento}
            alt="logo Museo Civico del Risorgimento"
          />
        </a>
        <a
          href="http://www.archiginnasio.it/"
          title="Archiginnasio"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoArchiginnasio} alt="logo Archiginnasio" />
        </a>
        <a
          href="https://www.8cento.org/?lang=it"
          title="8cento"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoOttocento} alt="logo 8cento" />
        </a>
        <a
          href="https://www.lookupradio.it"
          title="Radio Lookup"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logoRadio} alt="logo Radio Lookup" />
        </a>
      </div>
    </footer>
  );
}
